module.exports = __webpack_public_path__ + "assets/sphere.dc9256c0055bdba25ac60a36d1ee74ac.bin";